import { render, staticRenderFns } from "./CardManagementResult.vue?vue&type=template&id=2e0fe854&scoped=true"
import script from "./CardManagementResult.vue?vue&type=script&lang=js"
export * from "./CardManagementResult.vue?vue&type=script&lang=js"
import style0 from "./CardManagementResult.vue?vue&type=style&index=0&id=2e0fe854&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0fe854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0fe854')) {
      api.createRecord('2e0fe854', component.options)
    } else {
      api.reload('2e0fe854', component.options)
    }
    module.hot.accept("./CardManagementResult.vue?vue&type=template&id=2e0fe854&scoped=true", function () {
      api.rerender('2e0fe854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/CardManagementResult.vue"
export default component.exports